import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { useUserSettingsMenu } from 'src/zustand/stores/userSettingsMenu.store'

import { Icon, Timer } from '../ui'
import styles from './Header.module.scss'
import { Actions, Bell, Skip, Warning } from './components'

const Header = ({
  variant = 'main',
  setting,
  color = 'black',
  path = '/',
  share = '/',
  time = '00:00:00',
  action = 'skip',
  handleClickOnAction,
}: {
  variant?: 'main' | 'action' | 'settings' | 'bottles' | 'time' | 'back' | 'warning'
  setting?: string
  color?: 'white' | 'black'
  path?: string
  share?: string
  time?: string
  action?: 'skip' | 'add' | 'text'
  handleClickOnAction?: () => void
}) => {
  const location = useLocation()
  const { t } = useTranslation()

  const toggleMenu = useUserSettingsMenu((state) => state.toggleMenu)
  let content

  if (location.pathname === '/bottles') {
    variant = 'bottles'
  }

  switch (variant) {
    case 'main':
      content = (
        <>
          <button onClick={toggleMenu} type='button' className={styles.header_menu}>
            <span></span>
          </button>

          <Actions path='/transactions' variant='transactions' />
        </>
      )
      break

    case 'action':
      content = (
        <>
          <Actions path={path} />
          {action === 'skip' ? (
            <Skip onClick={handleClickOnAction} to={path} />
          ) : (
            <Actions path={path} variant='add-user' />
          )}
        </>
      )
      break

    case 'settings':
      content = (
        <>
          <Actions path={path} color={color} />
          <p className={styles[color]}>{t(`${setting}` || '')}</p>
        </>
      )
      break

    case 'bottles':
      content = (
        <>
          <Link className={styles.link} to='/create-bottle/step-1'>
            <Icon name='plus' />
            <p>{t('bottles_page.create_bank')}</p>
          </Link>

          <div className={styles.actions}>
            <Actions path='/banks-participation?mode=broken' variant='transactions' />
            <Bell />
          </div>
        </>
      )
      break

    case 'time':
      content = (
        <>
          <Actions path={path} variant='back' />

          <div className={styles.actions}>
            <Timer time={time} variant={action === 'text' ? 'text' : 'time'} />
            <Actions variant='share' path={share} />
          </div>
        </>
      )
      break

    case 'back':
      content = (
        <>
          <Actions variant='back' path={path || '..'} />
        </>
      )
      break

    case 'warning':
      content = (
        <>
          <Warning />
        </>
      )
      break
  }

  return <header className={`${styles.header} ${styles[variant]}`}>{content}</header>
}

export default Header
